'use client';

import {
  onFirstPageInteraction,
  readHasFirstPageInteraction,
} from '@/lib/ui/first-page-interaction';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';
let crispLoadPromise: Promise<void> | null = null;
let latestWebsiteId: string | null = null;
let latestLocale: string | null = null;

function isBrowser() {
  return typeof window !== 'undefined';
}

async function loadCrisp() {
  const websiteId = latestWebsiteId;
  if (!websiteId) {
    return;
  }

  if (!crispLoadPromise) {
    crispLoadPromise = import('crisp-sdk-web')
      .then(({ Crisp }) => {
        Crisp.configure(websiteId, {
          autoload: false,
          locale: latestLocale ?? undefined,
        });

        Crisp.load();
        Crisp.chat.show();
      })
      .catch((error) => {
        crispLoadPromise = null;

        if (process.env.NODE_ENV !== 'production') {
          console.error('[crisp-lazy-loader] Failed to load Crisp', error);
        }
      });
  }

  await crispLoadPromise;
}

export function CrispLazyLoader() {
  const locale = useLocale();

  useEffect(() => {
    const websiteId = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID?.trim();
    if (!websiteId) {
      return;
    }

    latestWebsiteId = websiteId;
    latestLocale = locale;

    if (readHasFirstPageInteraction()) {
      void loadCrisp();
      return;
    }

    return onFirstPageInteraction(() => {
      void loadCrisp();
    });
  }, [locale]);

  return null;
}
